export class QuoteRoutes {
  public static ROUTES = {

    Quote: {
      path: 'quote',
      fullPath: 'quote',
    },
    StepsPath: {
      path: 'steps',
      fullPath: 'quote/steps',
    },
    Steps: {
      StepMainData: {
        code: 'SMD',
        path: 'steps/main-data',
        fullPath: 'quote/steps/main-data',
        index: 0,
        isComplete: false,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepPremisesData: {
        code: 'SPD',
        path: 'steps/premises-data',
        fullPath: 'quote/steps/premises-data',
        index: 1,
        isComplete: false,
        img: '/assets/img/svg/step-2-blue.svg',
      },
      StepPricing: {
        code: 'STP',
        path: 'steps/pricing',
        fullPath: 'quote/steps/pricing',
        index: 2,
        isComplete: false,
        img: '/assets/img/svg/step-3-blue.svg',
      },
      StepCheckout: {
        code: 'STC',
        path: 'steps/checkout',
        fullPath: 'quote/steps/checkout',
        index: 3,
        isComplete: false,
        img: '/assets/img/svg/step-4-blue.svg',
      },
      StepEndQuote: {
        code: 'SEQ',
        path: 'steps/end-quote',
        fullPath: 'quote/steps/end-quote',
        index: 4,
      },
    },
    QuoteError: {
      code: 'RE',
      path: 'error',
      fullPath: 'quote/error',
    },
    HelpDesk: {
      path: 'help-desk',
      fullPath: 'quote/help-desk',
    },
    PoliciesSold: {
      path: 'policies-sold',
      fullPath: 'quote/policies-sold',
    },
    PolicySold: {
      path: 'policies-sold/:id',
      fullPath: 'quote/policies-sold/',
    },
  };
}
